import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../../../../../service";
import {
    IEntityWithIDTranslations,
    IEntityWithTranslations,
    IErrorResponse,
    IRootState
} from "../../../../../../../types";
import {deletedDisability,deletedRestoreDisability,setDisability,setDisabilityRestore, updateDisability} from "../store/disabilityGroupSlice";

const GetDisability = createAsyncThunk(
    "get/disability",
    async (_, { dispatch,rejectWithValue,getState }) => {
        try {
            const response = await request.get("/student-disability-group");
            const lang = getState()  as IRootState
            const defaultLanguage = lang.languages.defaultLanguage

            dispatch(setDisability({data:response.data,defaultLanguage}));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const SetDisability = createAsyncThunk(
    "set/disability",
    async (data: IEntityWithTranslations, { rejectWithValue }) => {
        try {
            const response = await request.post("/student-disability-group", data);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const DeleteDisability = createAsyncThunk(
    "delete/disability",
    async ( id : number, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.delete(`/student-disability-group/${id}`);

            dispatch(deletedDisability(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const EditDisability = createAsyncThunk(
    "edit/disability",
    async (data: IEntityWithIDTranslations, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/student-disability-group/${data.id}`, data);
            dispatch(updateDisability(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const GetDeleteDisability = createAsyncThunk(
    "get/delete/disability",
    async (_,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.get(`/student-disability-group/deleted-items`);

            dispatch(setDisabilityRestore(response.data));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const RestoreDeleteDisability= createAsyncThunk(
    "restore/delete/disability",
    async (id:number,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.post(`/student-disability-group/restore/${id}`);

            dispatch(deletedRestoreDisability(id));

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


export {
    GetDisability,
    SetDisability,
    DeleteDisability,
    EditDisability,
    GetDeleteDisability,
    RestoreDeleteDisability
};
